<template>
	<div>
		<el-button v-if="permissionExport" type="primary" @click="handleExport()" class="AddVillageBtn margin-bottom-10"><i class="el-icon-download"></i> 导出</el-button>
		<div style="float: right; margin-bottom: 10px;">
			<el-select v-model="searchName" slot="prepend" placeholder="请选择短信类别" style="width:200px" clearable >
	            <el-option label="后台登录" value="后台登录"></el-option>
	            <el-option label="用户登录" value="用户登录"></el-option>
	            <el-option label="用户注册" value="用户注册"></el-option>
	            <el-option label="用户安全设置" value="用户安全设置"></el-option>
	        </el-select>
			<el-button slot="append" icon="el-icon-search" type="primary" @keyup.enter="handleSearch" @click="handleSearch" style="margin-left:10px;">搜索</el-button>
		</div>
		<el-table
			v-if="permissionShow"
			v-loading="loading"
			element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			:data="tableData"
			border
			style="width: 100%"
			height="calc(100% - 100px)">
			<!--<el-table-column prop="sl_id" label="序号" sortable align="center"  min-width="90"></el-table-column>-->
			<el-table-column prop="sl_type" label="短信类别" sortable align="center" min-width="160"></el-table-column>
			<el-table-column prop="sl_phone" label="手机号码" sortable align="center" min-width="180"></el-table-column>
			<el-table-column prop="sl_code" label="短信验证码" sortable align="center" min-width="160"></el-table-column>
			<el-table-column prop="sl_content" label="短信内容" sortable align="center" min-width="360"></el-table-column>
			<el-table-column prop="sl_createtime" label="发送时间" sortable align="center" min-width="180"></el-table-column>
			<!-- <el-table-column
				fixed="right"
				label="操作"
				align="center"
				min-width="120"
				v-if="permissionExport">
				<template slot-scope="scope">
					<el-button @click="handleExport(scope.row)" type="text" size="small">导出</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!-- 分页 -->
		<div id="pagination">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				:page-size="limit"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'
// 时间过滤器
import {formatDate} from '@/filter/date.js'

export default {
	name: 'smsLog',
	data() {
		return {
			/* 
			 * tableData: 表格数据
			 * loading: 加载状态（默认为true）
			 * total: 总条数（table数据总长度）
			 * start: 表格分页（默认第一页）
			 * limit: 每页显示条数
			 * searchName: 搜索（用户名）
			 */
			tableData : [],
			loading : true,
			total: 0,
			start : 0,
			limit : 10,
			searchName: '',
			searchVal: '',
            searchData: {
                name1: ''
            },

			permissionShow: false, // 默认为false,根据权限是否显示
			permissionExport: false, // 默认为false,根据权限是否修改
		}
	},
	methods : {
		/* 获取权限 */
		getSubPermission() {
			this.$http.get(
				`${api.dev}/p/permission/getSub`,
				{
					params:{
						access_token:getToken(),
						p_id: this.$route.params.id
					}
				}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.forEach(item => {
						if(item.p_name.indexOf('显示') > -1) {
							this.permissionShow = true;
						}else if(item.p_name.indexOf('导出') > -1) {
							this.permissionExport = true;
						}
					})
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
        /* 搜索 */
        handleSearch(){
            this.searchData = {
                name1: this.searchName
            };
            this.getInfo();
        },
		/* 表格数据加载 */
		getInfo(){
			this.$http.post(
				`${api.dev}/p/main/smsLog/show`,
				{
					access_token: getToken(),
					start: this.start,
					limit: this.limit,
					name1: this.searchData.name1
				},
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.records.forEach(i => {
						i.sl_createtime = formatDate(new Date(i.sl_createtime) , 'yyyy-MM-dd hh:mm:ss');
					})

					this.tableData = res.body.content.records;
					this.total = res.body.content.total;
					this.loading = false;
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'})
					},2000)
				}
			})
		},
		/* 导出 */
		handleExport() {
			this.$confirm('是否要导出短信记录', '提示', {
				type: 'info'
			}).then(() => {
				window.location.href = `${api.dev}/p/main/smsLog/export?access_token=${getToken()}&name1=${this.searchVal}`;
			})
		},
		/* 分页 */
		handleCurrentChange(val) {
			this.loading = true;
			this.start = 10 * (val - 1);
			this.getInfo();
		}
	},
	created() {
		this.getSubPermission();
		this.getInfo();
	}
}
</script>


<style lang="stylus" scoped>
#pagination
	margin-top 10px
.margin-bottom-10
	margin-bottom 10px

</style>
